import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const DESPACHO_URL = import.meta.env.VITE_API_DESPACHO;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const BosService = {
    list: async (data) => axios.post(DESPACHO_URL + "/bogcm/list", data, {headers: {'Content-Type': 'application/json'}}).then(({data}) => data).catch((err) => { throw err }),

    smartSearch: async (data) => axios.post(API_KEEPER + "/bogcm/smart-search", data, {headers: {'Content-Type': 'application/json'}}).then(({data}) => data).catch((err) => { throw err }),

    createBogcm: async () => axios.post(DESPACHO_URL + "/bogcm/create").then(({data}) => data).catch((err) => { throw err }),

    update: async (formData) => axios.post(DESPACHO_URL + "/bogcm/update", formData).catch((err) => { throw err }),

    syncStart: async (formData) => axios.post(DESPACHO_URL + "/bogcm/sync/start", formData).then(({data}) => data).catch((err) => { throw err }),

    syncData: async (formData) => axios.post(DESPACHO_URL + "/bogcm/sync/syncData", formData).catch((err) => { throw err }),

    syncAttach: async (formData) => axios.post(DESPACHO_URL + "/bogcm/sync/syncAttach", formData).catch((err) => { throw err }),

    fullySynced: async (formData) => axios.post(DESPACHO_URL + "/bogcm/sync/setFullySynced", formData).catch((err) => { throw err }),

    startBasedOnExisting: async (formData) => axios.post(DESPACHO_URL + "/bogcm/sync/startBasedOnExisting", formData).then(({data}) => data).catch((err) => { throw err }),

    getNature: async () => axios.get(API_URL + `/nature/get/dispatchNatures`).then(({data}) => data).catch((err) => { throw err }),

    getTeams: async () => axios.get(API_URL + `/user/get/allTeams`).then(({data}) => data).catch((err) => { throw err }),

    getNameWar: async () => axios.get(API_URL + `/bos/get/allWithNameWar`).then(({data}) => data).catch((err) => { throw err }),

    getLeaders: async () => axios.get(API_URL + `/user/getUser/allLeaders`).then(({data}) => data).catch((err) => { throw err }),

    indexPermissions: async () => axios.get(API_URL + `/bos/get/indexPermissions`).then(({data}) => data).catch((err) => { throw err }),

    getBoName: async () => axios.get(API_URL + `/bos-name`).then(({data}) => data).catch((err) => { throw err }),

    getBoStatus: async () => axios.get(API_URL + `/bos/get/status`).then(({data}) => data.map(d => ({label: d.text, value: d.id}))).catch((err) => { throw err }),

    getBoSector: async () => axios.get(API_URL + `/bos/get/boSector`).then(({data}) => data.map(d => ({label: d.text, value: d.id}))).catch((err) => { throw err }),

    getBo: async (id) => axios.get(DESPACHO_URL + `/bogcm/get?id=${id}`).then(({data}) => data).catch((err) => { throw err }),

    getBoInfo: async (id) => axios.get(API_URL + `/bos/get-info/${id}`).then(({data}) => data).catch((err) => { throw err }),

    getLastStatus: async (id) => axios.get(DESPACHO_URL + `/bogcm/getLastStatus?id=${id}`).then(({data}) => data).catch((err) => { throw err }),

    getStatusHistoryByBoWeb: async (id) => axios.get(DESPACHO_URL + `/bogcm/getStatusHistoryByBoWeb?id=${id}`).then(({data}) => data).catch((err) => { throw err }),

    getOccurrenceFile: async (id) => axios.get(DESPACHO_URL + `/bogcm/getOccurrenceFile?bogcmId=${id}`).then(({data}) => data).catch((err) => { throw err }),

    uploadPdf: async (formData) => axios.post(DESPACHO_URL + `/bogcm/uploadPdf`, formData).catch((err) => { throw err }),

    getBoWebByEdit: async (id) => axios.get(DESPACHO_URL + `/bogcm/getBoWebByEdit?id=${id}`).then(({data}) => data).catch((err) => { throw err }),

    showBoDiff: async (params) => axios.get(DESPACHO_URL + `/bogcm/showBoDifferences`, params).then(({data}) => data).catch((err) => { throw err }),

    persist: async (formData) => axios.post(DESPACHO_URL + `/bogcm/sync/persist`, formData).then(({data}) => data).catch((err) => { throw err }),

    rejectedJustifications: async () => axios.get(API_URL + `/bos/get/allBosRejectedJustifications`).then(({data}) => data.map(d => ({label: d.text, value: d.id}))).catch((err) => { throw err }),

    approval: async (formData) => axios.post(DESPACHO_URL + `/bogcm/approval`, formData).catch((err) => { throw err }),

    invalidate: async (formData) => axios.post(DESPACHO_URL + `/bogcm/invalidate`, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).catch((err) => { throw err }),

    rectify: async (formData) => axios.post(DESPACHO_URL + `/bogcm/rectify`, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).catch((err) => { throw err }),

    addOtherDocument: async (formData) => axios.post(DESPACHO_URL + `/bogcm/addOtherDocument`, formData).catch((err) => { throw err }),

    otherDocuments: async () => axios.get(API_URL + `/bos/get/otherDocuments`).then(({data}) => data).catch((err) => { throw err }),

    getByCpf: async (cpf) => axios.post(API_URL + `/api/bos/individuals`, {cpf}).then(({data}) => data).catch((err) => { throw err }),

    getTagOptions: async () => axios.get(API_URL + "/bos-tags/options").then(({ data }) => data).catch((err) => { throw err }),

    updateTags: async (formData) => axios.post(DESPACHO_URL + "/bogcm/updateTags", formData).then(({ data }) => data).catch((err) => { throw err }),
    getContingents: async () => axios.get(API_URL + `/despacho/garrison/contingents`).then(({data}) => data).catch((err) => { throw err }),

}

export default BosService;
